module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-challenge-videoPoster.jpg?h=9fd33f27471cbb6cc9ae0f52726687fe";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-challenge-videoPoster.jpg
// module id = 2104
// module chunks = 12 15